var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"operation-page"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"content"},[_vm._t("default")],2),_c('div',{staticClass:"bottom"},[_c('div',{staticClass:"btn-next",on:{"click":function($event){return _vm.$emit('next')}}},[_vm._v(_vm._s(_vm.btn))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }